export default {
  id: 'healthProfile',
  version: '20',
  type: 'formulary',
  children: [
    {
      type: 'section',
      children: [
        {
          id: 'occupation.current',
          version: '2',
          type: 'composite',
          children: [
            {
              id: 'occupation.current.what',
              type: 'choice',
              options: [
                {
                  value: 'working',
                  label: 'Arbetar',
                },
                {
                  value: 'student',
                  label: 'Studerar',
                },
                {
                  value: 'sicklisted',
                  label: 'Sjukskriven',
                },
                {
                  value: 'parentalleave',
                  label: 'Föräldraledig',
                },
                {
                  value: 'retired',
                  label: 'Pensionär',
                },
                {
                  value: 'jobseeking',
                  label: 'Arbetssökande',
                },
                {
                  value: 'other',
                  label: 'Annat',
                },
              ],
              expires: 180,
              relativeId: 'what',
              version: '2',
              validations: {
                required: true,
              },
              label: 'Vad är din huvudsakliga sysselsättning?',
              index: '0.0.0.0',
            },
            {
              id: 'occupation.current.other',
              type: 'text',
              condition: "get('answers.occupation.current.what') === 'other'",
              expires: 900,
              relativeId: 'other',
              version: '2',
              validations: {
                required: true,
              },
              label: 'Beskriv din huvudsakliga sysselsättning.',
              index: '0.0.0.1',
            },
          ],
          extras: {},
          index: '0.0.0',
        },
        {
          id: 'work.what',
          type: 'text',
          version: '3',
          expires: 180,
          condition: "get('answers.occupation.current.what') === 'working'",
          validations: {
            required: true,
          },
          label: 'Vad arbetar du med?',
          index: '0.0.1',
        },
        {
          id: 'occupation.sicklisted',
          version: '1',
          type: 'text',
          expires: 90,
          condition: "get('answers.occupation.current.what') === 'sicklisted'",
          validations: {
            required: true,
          },
          label: 'Varför är du sjukskriven?',
          index: '0.0.2',
        },
        {
          id: 'occupation.sicklistedSince',
          version: '1',
          type: 'text',
          expires: 90,
          condition: "get('answers.occupation.current.what') === 'sicklisted'",
          validations: {
            required: true,
          },
          label: 'Vilket datum började din senaste sjukskrivningsperiod?',
          index: '0.0.3',
        },
        {
          id: 'height',
          type: 'number',
          version: '2',
          unit: 'cm',
          validations: {
            required: true,
            min: 50,
            max: 300,
          },
          expires: 99999,
          label: 'Hur lång är du?',
          index: '0.0.4',
        },
        {
          id: 'weight',
          type: 'number',
          version: '2',
          unit: 'kg',
          validations: {
            required: true,
            min: 20,
            max: 700,
          },
          expires: 180,
          label: 'Hur mycket väger du?',
          index: '0.0.5',
        },
        {
          id: 'smoking.status',
          type: 'choice',
          version: '1',
          options: [
            {
              value: 1,
              label: 'Ja',
            },
            {
              value: 2,
              label: 'Nej',
            },
            {
              value: 3,
              label: 'Före detta',
            },
          ],
          expires: 180,
          validations: {
            required: true,
          },
          label: 'Är du rökare?',
          index: '0.0.6',
        },
        {
          id: 'smoking.amount',
          type: 'choice',
          version: '1',
          options: [
            {
              value: 'lessthan10',
              label: 'Färre än tio',
            },
            {
              value: 'more',
              label: 'Tio eller fler',
            },
          ],
          expires: 180,
          condition: "get('answers.smoking.status') === 1",
          validations: {
            required: true,
          },
          label: 'Hur många cigaretter röker du per dag?',
          index: '0.0.7',
        },
        {
          id: 'alcohol.amountFemale',
          type: 'choice',
          version: '2',
          options: [
            {
              value: 'more',
              label: '9 standardglas i veckan eller mer',
            },
            {
              value: 'less',
              label: 'Mindre än 9 standardglas i veckan',
            },
            {
              value: 'none',
              label: 'Jag dricker inte alkohol',
            },
          ],
          expires: 180,
          condition: "get('answers.predefined.gender') !== 'male'",
          validations: {
            required: true,
          },
          label: 'Hur mycket alkohol dricker du?',
          description:
            'Ett standardglas motsvarar ett glas vin, en flaska starköl (33 cl) eller 4 cl starksprit.',
          index: '0.0.8',
        },
        {
          id: 'alcohol.amountMale',
          type: 'choice',
          version: '2',
          options: [
            {
              value: 'more',
              label: '14 standardglas i veckan eller mer',
            },
            {
              value: 'less',
              label: 'Mindre än 14 standardglas i veckan',
            },
            {
              value: 'none',
              label: 'Jag dricker inte alkohol',
            },
          ],
          expires: 180,
          condition: "get('answers.predefined.gender') === 'male'",
          validations: {
            required: true,
          },
          label: 'Hur mycket alkohol dricker du?',
          description:
            'Ett standardglas motsvarar ett glas vin, en flaska starköl (33 cl) eller 4 cl starksprit.',
          index: '0.0.9',
        },
        {
          id: 'health.issues.what',
          version: '2',
          type: 'multipleChoice',
          options: [
            {
              value: 'bloodpreassure',
              label: 'Högt blodtryck med tablettbehandling',
            },
            {
              value: 'cardiovascular',
              label: 'Hjärt-kärlsjukdom',
            },
            {
              value: 'diabetes',
              label: 'Diabetes',
            },
            {
              value: 'lungs',
              label: 'Lungsjukdom',
            },
            {
              value: 'cancer',
              label: 'Cancersjukdom',
            },
            {
              value: 'neuro',
              label: 'Neurologisk sjukdom',
            },
            {
              value: 'blooddisease',
              label: 'Blodsmitta (HIV, Hepatit B, Hepatit C)',
            },
            {
              value: 'kidney',
              label: 'Njurfunktionsnedsättning',
            },
            {
              value: 'liver',
              label: 'Leverfunktionsnedsättning',
            },
          ],
          expires: 900,
          validations: {
            required: false,
          },
          label:
            'Markera de sjukdomar eller hälsoproblem du har, eller har haft.',
          description: 'Flera svarsalternativ möjliga.',
          index: '0.0.10',
        },
        {
          id: 'health.cardiovascular.what',
          type: 'composite',
          version: '1',
          children: [
            {
              id: 'health.cardiovascular.what.what',
              type: 'multipleChoice',
              options: [
                {
                  value: 'infarction',
                  label: 'Hjärtinfarkt',
                },
                {
                  value: 'congestiveHeart',
                  label: 'Hjärtsvikt',
                },
                {
                  value: 'anginaPectoris',
                  label: 'Kärlkramp',
                },
                {
                  value: 'atrialFibrillation',
                  label: 'Förmaksflimmer',
                },
                {
                  value: 'heartValve',
                  label: 'Hjärtklaffsfel',
                },
                {
                  value: 'stroke',
                  label: 'Stroke',
                },
                {
                  value: 'bloodClot',
                  label: 'Blodpropp som krävt blodförtunnande medicinering',
                },
                {
                  value: 'other',
                  label: 'Annan hjärt-kärlsjukdom',
                },
              ],
              validations: {
                required: true,
              },
              expires: 900,
              relativeId: 'what',
              version: '1',
              label: 'Vilka hjärt-kärlsjukdomar har du, eller har du haft?',
              index: '0.0.11.0',
            },
            {
              id: 'health.cardiovascular.what.other',
              type: 'text',
              condition:
                "contains(get('answers.health.cardiovascular.what.what'), 'other')",
              expires: 900,
              relativeId: 'other',
              version: '1',
              validations: {
                required: true,
              },
              label: 'Vilken hjärt-kärlsjukdom har du, eller har du haft?',
              index: '0.0.11.1',
            },
          ],
          condition:
            "contains(get('answers.health.issues.what'), 'cardiovascular')",
          extras: {},
          index: '0.0.11',
        },
        {
          id: 'health.diabetes.type',
          version: '1',
          type: 'multipleChoice',
          options: [
            {
              value: 'type1',
              label: 'Diabetes typ 1',
            },
            {
              value: 'type2',
              label: 'Diabetes typ 2',
            },
            {
              value: 'other',
              label: 'Annat',
            },
          ],
          expires: 900,
          validations: {
            required: true,
          },
          condition: "contains(get('answers.health.issues.what'), 'diabetes')",
          label: 'Vilken typ av diabetes har du?',
          description: 'Flera svarsalternativ möjliga.',
          index: '0.0.12',
        },
        {
          id: 'health.diabetes.typeOther',
          version: '1',
          type: 'text',
          expires: 900,
          condition: "contains(get('answers.health.diabetes.type'), 'other')",
          validations: {
            required: true,
          },
          label: 'Vilken typ av diabetes har du?',
          index: '0.0.13',
        },
        {
          id: 'health.diabetes.treatment',
          version: '2',
          type: 'multipleChoice',
          options: [
            {
              value: 'food',
              label: 'Kostbehandling',
            },
            {
              value: 'pills',
              label: 'Tablettbehandling',
            },
            {
              value: 'insuline',
              label: 'Insulinbehandling',
            },
          ],
          expires: 900,
          validations: {
            required: true,
          },
          condition: "contains(get('answers.health.issues.what'), 'diabetes')",
          label: 'Hur behandlas du för din diabetes?',
          description: 'Flera svarsalternativ möjliga.',
          index: '0.0.14',
        },
        {
          id: 'health.lungDiseases.what',
          type: 'composite',
          version: '1',
          children: [
            {
              id: 'health.lungDiseases.what.what',
              type: 'multipleChoice',
              options: [
                {
                  value: 'astma',
                  label: 'Astma',
                },
                {
                  value: 'kol',
                  label: 'KOL',
                },
                {
                  value: 'other',
                  label: 'Annan lungsjukdom',
                },
              ],
              validations: {
                required: true,
              },
              expires: 900,
              relativeId: 'what',
              version: '1',
              label: 'Vilka lungsjukdomar har du, eller har du haft?',
              description: 'Flera svarsalternativ möjliga.',
              index: '0.0.15.0',
            },
            {
              id: 'health.lungDiseases.what.other',
              type: 'text',
              condition:
                "contains(get('answers.health.lungDiseases.what.what'), 'other')",
              expires: 900,
              relativeId: 'other',
              version: '1',
              validations: {
                required: true,
              },
              label: 'Vilken lungsjukdom har du, eller har du haft?',
              index: '0.0.15.1',
            },
          ],
          condition: "contains(get('answers.health.issues.what'), 'lungs')",
          extras: {},
          index: '0.0.15',
        },
        {
          id: 'health.cancerWhat',
          type: 'text',
          expires: 900,
          version: '1',
          condition: "contains(get('answers.health.issues.what'), 'cancer')",
          validations: {
            required: true,
          },
          label: 'Vilken cancersjukdom har du, eller har du haft?',
          index: '0.0.16',
        },
        {
          id: 'health.cancerYearDiagnosed',
          type: 'text',
          version: '1',
          expires: 900,
          condition: "contains(get('answers.health.issues.what'), 'cancer')",
          validations: {
            required: true,
          },
          label: 'Vilket år fick du din cancerdiagnos?',
          index: '0.0.17',
        },
        {
          id: 'health.cancerAffected.match',
          type: 'binary',
          version: '1',
          expires: 900,
          condition: "contains(get('answers.health.issues.what'), 'cancer')",
          validations: {
            required: true,
          },
          label: 'Är ditt hälsotillstånd i dagsläget påverkat av din cancer?',
          index: '0.0.18',
        },
        {
          id: 'health.cancerAffected.how',
          type: 'text',
          version: '1',
          expires: 900,
          condition: "get('answers.health.cancerAffected.match') === 'yes'",
          validations: {
            required: true,
          },
          label:
            'På vilket sätt är ditt hälsotillstånd i dagsläget påverkat av din cancer?',
          index: '0.0.19',
        },
        {
          id: 'health.neurological.what',
          type: 'composite',
          version: '1',
          children: [
            {
              id: 'health.neurological.what.what',
              type: 'multipleChoice',
              options: [
                {
                  value: 'epilepsy',
                  label: 'Epilepsi',
                },
                {
                  value: 'ms',
                  label: 'MS',
                },
                {
                  value: 'parkinson',
                  label: 'Parkinson',
                },
                {
                  value: 'other',
                  label: 'Annan neurologisk sjukdom',
                },
              ],
              validations: {
                required: true,
              },
              expires: 900,
              relativeId: 'what',
              version: '1',
              label: 'Vilka neurologiska sjukdomar har du, eller har du haft?',
              index: '0.0.20.0',
            },
            {
              id: 'health.neurological.what.other',
              type: 'text',
              condition:
                "contains(get('answers.health.neurological.what.what'), 'other')",
              expires: 900,
              relativeId: 'other',
              version: '1',
              validations: {
                required: true,
              },
              label: 'Vilken neurologisk sjukdom har du, eller har du haft?',
              index: '0.0.20.1',
            },
          ],
          condition: "contains(get('answers.health.issues.what'), 'neuro')",
          extras: {},
          index: '0.0.20',
        },
        {
          id: 'health.bloodDisease.what',
          version: '1',
          type: 'multipleChoice',
          options: [
            {
              value: 'hepB',
              label: 'Hepatit B',
            },
            {
              value: 'hepC',
              label: 'Hepatit C',
            },
            {
              value: 'hiv',
              label: 'HIV',
            },
          ],
          validations: {
            required: true,
          },
          expires: 900,
          condition:
            "contains(get('answers.health.issues.what'), 'blooddisease')",
          label: 'Vilken blodsmitta har du, eller har du haft?',
          index: '0.0.21',
        },
        {
          id: 'health.operation.match',
          type: 'binary',
          version: '1',
          expires: 900,
          validations: {
            required: true,
          },
          label: 'Har du genomgått någon större operation?',
          index: '0.0.22',
        },
        {
          id: 'health.operation.what',
          type: 'text',
          version: '1',
          expires: 900,
          condition: "get('answers.health.operation.match') === 'yes'",
          validations: {
            required: true,
          },
          label: 'Vilken större operation har du genomgått?',
          index: '0.0.23',
        },
        {
          id: 'health.relativesCancer',
          type: 'tertiary',
          version: '1',
          expires: 900,
          validations: {
            required: true,
          },
          label:
            'Har någon av dina (biologiska) föräldrar eller syskon drabbats av cancer?',
          index: '0.0.24',
        },
        {
          id: 'health.relativesCardiovascular',
          type: 'tertiary',
          version: '1',
          expires: 900,
          validations: {
            required: true,
          },
          label:
            'Har någon av dina (biologiska) föräldrar eller syskon drabbats av hjärt-kärlsjukdom?',
          index: '0.0.25',
        },
        {
          id: 'health.relativesDiabetes',
          type: 'tertiary',
          version: '1',
          expires: 900,
          validations: {
            required: true,
          },
          label:
            'Har någon av dina (biologiska) föräldrar eller syskon drabbats av diabetes?',
          index: '0.0.26',
        },
        {
          id: 'medication.current',
          type: 'composite',
          version: '4',
          children: [
            {
              id: 'medication.current.anyFemale',
              type: 'binary',
              condition: "get('answers.predefined.gender') === 'female'",
              expires: 180,
              relativeId: 'anyFemale',
              version: '4',
              validations: {
                required: true,
              },
              label: 'Använder du några läkemedel för tillfället?',
              description:
                'Om du använder hormonella preventivmedel bör även detta uppges.',
              index: '0.0.27.0',
            },
            {
              id: 'medication.current.anyMale',
              type: 'binary',
              condition: "get('answers.predefined.gender') === 'male'",
              expires: 180,
              relativeId: 'anyMale',
              version: '4',
              validations: {
                required: true,
              },
              label: 'Använder du några läkemedel för tillfället?',
              index: '0.0.27.1',
            },
            {
              id: 'medication.current.what',
              type: 'text',
              condition:
                "get('answers.medication.current.anyFemale') === 'yes' || get('answers.medication.current.anyMale') === 'yes'",
              expires: 180,
              relativeId: 'what',
              version: '4',
              validations: {
                required: true,
              },
              label: 'Vilka läkemedel tar du?',
              description:
                'Ange läkemedel, styrka och dos, t.ex. Levaxin, 100 mikrogram, 1 tablett 1 gång/dag. Om du vet av vilken anledning du tar läkemedlet, ange detta.',
              index: '0.0.27.2',
            },
          ],
          extras: {},
          index: '0.0.27',
        },
        {
          id: 'medication.packaged',
          type: 'binary',
          version: '5',
          expires: 180,
          condition:
            "get('answers.medication.current.anyFemale') === 'yes' || get('answers.medication.current.anyMale') === 'yes'",
          validations: {
            required: true,
          },
          label:
            'Får du dina läkemedel förberedda i små plastpåsar (en påse per doseringstillfälle), märkta med personuppgifter, vilka läkemedel påsen innehåller samt datum och tid för när dessa ska tas?',
          description:
            '![hejhej](data:image/png;base64,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)',
          index: '0.0.28',
        },
        {
          id: 'medication.deliveryHelp.match',
          type: 'binary',
          version: '3',
          expires: 180,
          condition:
            "get('answers.medication.current.anyFemale') === 'yes' || get('answers.medication.current.anyMale') === 'yes'",
          validations: {
            required: true,
          },
          label:
            'Får du särskild hjälp med utdelning av dina läkemedel av hemtjänst, vårdcentral, mottagning eller liknande?',
          index: '0.0.29',
        },
        {
          id: 'medication.deliveryHelp.what',
          type: 'text',
          version: '2',
          expires: 180,
          condition: "get('answers.medication.deliveryHelp.match') === 'yes'",
          validations: {
            required: true,
          },
          label: 'Beskriv vilken typ av hjälp med utdelning du får.',
          index: '0.0.30',
        },
        {
          id: 'medication.naturopathic',
          type: 'composite',
          version: '1',
          children: [
            {
              id: 'medication.naturopathic.any',
              type: 'binary',
              expires: 180,
              relativeId: 'any',
              version: '1',
              validations: {
                required: true,
              },
              label:
                'Använder du några natur- eller hälsokostpreparat för tillfället?',
              index: '0.0.31.0',
            },
            {
              id: 'medication.naturopathic.what',
              type: 'text',
              condition: "get('answers.medication.naturopathic.any') === 'yes'",
              expires: 180,
              relativeId: 'what',
              version: '1',
              validations: {
                required: true,
              },
              label: 'Vilka natur- eller hälsokostpreparat tar du?',
              index: '0.0.31.1',
            },
          ],
          extras: {},
          index: '0.0.31',
        },
        {
          id: 'allergy.penicillinMatch',
          type: 'choice',
          version: '1',
          options: [
            {
              value: 'yesKnows',
              label:
                'Ja, och jag vet vilken sorts penicillin eller antibiotika jag är allergisk mot.',
            },
            {
              value: 'yesDontKnow',
              label:
                'Ja, men jag vet inte vilken sorts penicillin eller antibiotika jag är allergisk mot.',
            },
            {
              value: 'no',
              label: 'Nej',
            },
            {
              value: 'dontKnow',
              label: 'Vet ej',
            },
          ],
          expires: 180,
          validations: {
            required: true,
          },
          label: 'Är du allergisk mot penicillin eller annan antibiotika?',
          index: '0.0.32',
        },
        {
          id: 'allergy.penicillinWhat',
          type: 'multipleChoice',
          version: '1',
          options: [
            {
              value: 'penicillins',
              label:
                'Penicilliner (t.ex. Amimox, Amoxicillin, Avopenin, Bioclavid, Calciopen, Flukloxacillin, Imacillin, Heracillin, Klaximol, Kåvepenin, Penomax, Selexid, Spektramox, Tikacillin)',
            },
            {
              value: 'azitromycin',
              label: 'Azitromycin (t.ex. Azitromax)',
            },
            {
              value: 'cefadroxil',
              label: 'Cefadroxil (t.ex. Cefamox)',
            },
            {
              value: 'ciprofloxacin',
              label: 'Ciprofloxacin (t.ex. Ciproxin)',
            },
            {
              value: 'erytromycin',
              label: 'Erytromycin (t.ex. Abboticin, Ery-Max)',
            },
            {
              value: 'klindamycin',
              label: 'Klindamycin (t.ex. Dalacin)',
            },
            {
              value: 'nitrofurantoin',
              label: 'Nitrofurantoin (t.ex. Furadantin)',
            },
            {
              value: 'norfloxacin',
              label: 'Norfloxacin (t.ex. Lexinor)',
            },
            {
              value: 'sulfa',
              label:
                'Sulfa (t.ex. Bactrim, Bactrim forte, Eusaprim, Eusaprim forte)',
            },
            {
              value: 'tetracykliner',
              label:
                'Tetracykliner (t.ex. Doxyferm, Lymelysal, Tetracyklin, Tetralysal)',
            },
            {
              value: 'trimetoprim',
              label: 'Trimetoprim (t.ex. Idotrim)',
            },
            {
              value: 'other',
              label: 'Annat',
            },
          ],
          expires: 180,
          validations: {
            required: true,
          },
          condition: "get('answers.allergy.penicillinMatch') === 'yesKnows'",
          label:
            'Vilken typ av penicillin eller annan antibiotika är du allergisk mot?',
          description: 'Flera svarsalternativ möjliga.',
          index: '0.0.33',
        },
        {
          id: 'allergy.penicillinOther',
          type: 'text',
          version: '1',
          expires: 180,
          condition: "contains(get('answers.allergy.penicillinWhat'), 'other')",
          validations: {
            required: true,
          },
          label:
            'Vilken typ av penicillin eller annan antibiotika är du allergisk mot?',
          index: '0.0.34',
        },
        {
          id: 'allergy.penicillinReaction',
          type: 'multipleChoice',
          version: '1',
          options: [
            {
              value: 'severe',
              label:
                'Allvarlig reaktion med t.ex. andningssvårigheter och svullnad i mun och svalg',
            },
            {
              value: 'light',
              label: 'Lättare besvär såsom hudutslag och klåda',
            },
            {
              value: 'other',
              label: 'Annat',
            },
          ],
          expires: 180,
          validations: {
            required: true,
          },
          condition: "contains(get('answers.allergy.penicillinMatch'), 'yes')",
          label: 'Hur reagerade du på penicillinet/antibiotikan?',
          description: 'Flera svarsalternativ möjliga.',
          index: '0.0.35',
        },
        {
          id: 'allergy.penicillinReactionOther',
          type: 'text',
          version: '1',
          expires: 180,
          condition:
            "contains(get('answers.allergy.penicillinReaction'), 'other')",
          validations: {
            required: true,
          },
          label: 'Beskriv hur du reagerade på penicillinet/antibiotikan.',
          index: '0.0.36',
        },
        {
          id: 'allergy.medication',
          type: 'composite',
          version: '4',
          children: [
            {
              id: 'allergy.medication.any',
              type: 'tertiary',
              expires: 180,
              relativeId: 'any',
              version: '4',
              validations: {
                required: true,
              },
              label:
                'Förutom penicillin eller annan antibiotika, finns det andra läkemedel som du vet att du är allergisk mot, eller har fått biverkningar av?',
              index: '0.0.37.0',
            },
            {
              id: 'allergy.medication.what',
              type: 'text',
              condition: "get('answers.allergy.medication.any') === 'yes'",
              expires: 900,
              relativeId: 'what',
              version: '4',
              validations: {
                required: true,
              },
              label:
                'Vilka andra läkemedel är du allergisk mot, eller har fått biverkningar av?',
              index: '0.0.37.1',
            },
          ],
          extras: {},
          index: '0.0.37',
        },
        {
          id: 'allergy.other',
          type: 'composite',
          version: '2-complex',
          children: [
            {
              id: 'allergy.other.any',
              type: 'binary',
              expires: 180,
              relativeId: 'any',
              version: '2-complex',
              validations: {
                required: true,
              },
              label: 'Har du några andra kända allergier?',
              description: 'T.ex. husdjur eller pollen.',
              index: '0.0.38.0',
            },
            {
              id: 'allergy.other.what',
              type: 'multipleChoice',
              condition: "get('answers.allergy.other.any') === 'yes'",
              expires: 900,
              options: [
                {
                  value: 'pollen',
                  label: 'Pollen',
                },
                {
                  value: 'fur',
                  label: 'Pälsdjur',
                },
                {
                  value: 'mite',
                  label: 'Kvalster',
                },
                {
                  value: 'food',
                  label: 'Födoämnen',
                },
                {
                  value: 'other',
                  label: 'Annat',
                },
              ],
              validations: {
                required: true,
              },
              relativeId: 'what',
              version: '2-complex',
              label: 'Vad är du allergisk mot?',
              description: 'Flera svarsalternativ möjliga.',
              index: '0.0.38.1',
            },
            {
              id: 'allergy.other.other',
              type: 'text',
              condition: "contains(get('answers.allergy.other.what'), 'other')",
              expires: 900,
              relativeId: 'other',
              version: '2-complex',
              validations: {
                required: true,
              },
              label: 'Vad är du allergisk mot?',
              index: '0.0.38.2',
            },
          ],
          extras: {},
          index: '0.0.38',
        },
        {
          id: 'otherChoice',
          version: '2-expiry',
          type: 'binary',
          expires: 99999,
          validations: {
            required: true,
          },
          label: 'Övrigt',
          description:
            'Finns det något mer angående din allmänna hälsostatus som du tror vi kan behöva veta?',
          index: '0.0.39',
        },
        {
          id: 'other',
          version: '3-expiry',
          type: 'text',
          expires: 99999,
          condition: "get('answers.otherChoice') === 'yes'",
          validations: {
            required: true,
          },
          label:
            'Vad mer angående din allmänna hälsostatus skulle du vilja förmedla?',
          index: '0.0.40',
        },
      ],
      version: '1',
      index: '0.0',
    },
    {
      id: 'predefined.gender',
      type: 'predefined',
      version: '1',
      validations: {
        required: true,
      },
      index: '0.1',
    },
  ],
  variables: [
    {
      id: 'healthProfile.bmi',
      type: 'number',
      expression:
        "(get('answers.height') < 1 ? 1 : get('answers.weight') * (get('answers.height') < 50 ? 1 : 10000) / (get('answers.height') * get('answers.height')))",
      relativeId: 'bmi',
      version: '1',
      validations: {
        required: true,
      },
    },
  ],
  views: {
    clinic: {
      children: [
        {
          id: 'occupation.current.what',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Huvudsaklig sysselsättning',
          options: [
            {
              value: 'working',
              label: 'Arbetar',
            },
            {
              value: 'student',
              label: 'Studerar',
            },
            {
              value: 'sicklisted',
              label: 'Sjukskriven',
            },
            {
              value: 'parentalleave',
              label: 'Föräldraledig',
            },
            {
              value: 'retired',
              label: 'Pensionär',
            },
            {
              value: 'jobseeking',
              label: 'Arbetssökande',
            },
            {
              value: 'other',
              label: 'Annat',
            },
          ],
        },
        {
          id: 'work.what',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Arbetar med',
        },
        {
          id: 'occupation.sicklisted',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Anledning till sjukskrivning',
        },
        {
          id: 'occupation.sicklistedSince',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Senaste sjukskrivningsperiod påbörjad datum',
        },
        {
          id: 'occupation.current.other',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Annan huvudsaklig sysselsättning',
        },
        {
          id: 'height',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Längd',
          unit: 'cm',
        },
        {
          id: 'weight',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Vikt',
          unit: 'kg',
        },
        {
          id: 'clinic.bmitext',
          type: 'text',
          warning:
            "get('variables.healthProfile.bmi') >= 35 || (get('variables.healthProfile.bmi') > 1 && get('variables.healthProfile.bmi') < 17)",
          version: '1',
          validations: {
            required: true,
          },
          label: 'BMI',
          template:
            "((!get('variables.healthProfile.bmi') || get('variables.healthProfile.bmi') < 2) ? '-' : (get('variables.healthProfile.bmi')).toFixed(1) + ' ' + (get('variables.healthProfile.bmi') < 18.5 ? '(Undervikt)' : (get('variables.healthProfile.bmi') < 25 ? '(Normalvikt)' : (get('variables.healthProfile.bmi') < 30 ? '(Övervikt)' : '(Fetma)'))))",
        },
        {
          id: 'smoking.status',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Rökning',
          options: [
            {
              value: 1,
              label: 'Ja',
            },
            {
              value: 2,
              label: 'Nej',
            },
            {
              value: 3,
              label: 'Före detta',
            },
          ],
        },
        {
          id: 'smoking.amount',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Antal cigaretter/dag',
          options: [
            {
              value: 'lessthan10',
              label: 'Färre än tio',
            },
            {
              value: 'more',
              label: 'Tio eller fler',
            },
          ],
        },
        {
          id: 'alcohol.amountFemale',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Alkoholkonsumtion',
          description: '',
          options: [
            {
              value: 'more',
              label: '9 standardglas i veckan eller mer',
            },
            {
              value: 'less',
              label: 'Mindre än 9 standardglas i veckan',
            },
            {
              value: 'none',
              label: 'Jag dricker inte alkohol',
            },
          ],
        },
        {
          id: 'alcohol.amountMale',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Alkoholkonsumtion',
          description: '',
          options: [
            {
              value: 'more',
              label: '14 standardglas i veckan eller mer',
            },
            {
              value: 'less',
              label: 'Mindre än 14 standardglas i veckan',
            },
            {
              value: 'none',
              label: 'Jag dricker inte alkohol',
            },
          ],
        },
        {
          id: 'health.issues.what',
          warning: "length(get('answers.health.issues.what')) !== 0",
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Tidigare och/eller nuvarande sjukdomar',
          description: '',
          options: [
            {
              value: 'bloodpreassure',
              label: 'Högt blodtryck med tablettbehandling',
            },
            {
              value: 'cardiovascular',
              label: 'Hjärt-kärlsjukdom',
            },
            {
              value: 'diabetes',
              label: 'Diabetes',
            },
            {
              value: 'lungs',
              label: 'Lungsjukdom',
            },
            {
              value: 'cancer',
              label: 'Cancersjukdom',
            },
            {
              value: 'neuro',
              label: 'Neurologisk sjukdom',
            },
            {
              value: 'blooddisease',
              label: 'Blodsmitta (HIV, Hepatit B, Hepatit C)',
            },
            {
              value: 'kidney',
              label: 'Njurfunktionsnedsättning',
            },
            {
              value: 'liver',
              label: 'Leverfunktionsnedsättning',
            },
          ],
        },
        {
          id: 'health.cardiovascular.what.what',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Hjärt-kärlsjukdom',
          options: [
            {
              value: 'infarction',
              label: 'Hjärtinfarkt',
            },
            {
              value: 'congestiveHeart',
              label: 'Hjärtsvikt',
            },
            {
              value: 'anginaPectoris',
              label: 'Kärlkramp',
            },
            {
              value: 'atrialFibrillation',
              label: 'Förmaksflimmer',
            },
            {
              value: 'heartValve',
              label: 'Hjärtklaffsfel',
            },
            {
              value: 'stroke',
              label: 'Stroke',
            },
            {
              value: 'bloodClot',
              label: 'Blodpropp som krävt blodförtunnande medicinering',
            },
            {
              value: 'other',
              label: 'Annan hjärt-kärlsjukdom',
            },
          ],
        },
        {
          id: 'health.cardiovascular.what.other',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Fri beskrivning annan hjärt-kärlsjukdom',
        },
        {
          id: 'health.diabetes.type',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Typ av diabetes',
          description: '',
          options: [
            {
              value: 'type1',
              label: 'Diabetes typ 1',
            },
            {
              value: 'type2',
              label: 'Diabetes typ 2',
            },
            {
              value: 'other',
              label: 'Annat',
            },
          ],
        },
        {
          id: 'health.diabetes.typeOther',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Typ av diabetes, annat',
          description: '',
        },
        {
          id: 'health.diabetes.treatment',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Diabetes behandlas med',
          description: '',
          options: [
            {
              value: 'food',
              label: 'Kostbehandling',
            },
            {
              value: 'pills',
              label: 'Tablettbehandling',
            },
            {
              value: 'insuline',
              label: 'Insulinbehandling',
            },
          ],
        },
        {
          id: 'health.lungDiseases.what.what',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Lungsjukdom',
          description: '',
          options: [
            {
              value: 'astma',
              label: 'Astma',
            },
            {
              value: 'kol',
              label: 'KOL',
            },
            {
              value: 'other',
              label: 'Annan lungsjukdom',
            },
          ],
        },
        {
          id: 'health.lungDiseases.what.other',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Fri beskrivning annan lungsjukdom',
        },
        {
          id: 'health.cancerWhat',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Cancersjukdom',
        },
        {
          id: 'health.cancerYearDiagnosed',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Diagnosticerad (cancer)',
        },
        {
          id: 'health.cancerAffected.match',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Har aktuella besvär på grund av cancer',
        },
        {
          id: 'health.cancerAffected.how',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Beskrivning av aktuella besvär på grund av cancer',
        },
        {
          id: 'health.neurological.what.what',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Neurologisk sjukdom',
          options: [
            {
              value: 'epilepsy',
              label: 'Epilepsi',
            },
            {
              value: 'ms',
              label: 'MS',
            },
            {
              value: 'parkinson',
              label: 'Parkinson',
            },
            {
              value: 'other',
              label: 'Annan neurologisk sjukdom',
            },
          ],
        },
        {
          id: 'health.neurological.what.other',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Fri beskrivning annan neurologisk sjukdom',
        },
        {
          id: 'health.bloodDisease.what',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Blodsmitta',
          options: [
            {
              value: 'hepB',
              label: 'Hepatit B',
            },
            {
              value: 'hepC',
              label: 'Hepatit C',
            },
            {
              value: 'hiv',
              label: 'HIV',
            },
          ],
        },
        {
          id: 'health.operation.match',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Har genomgått större operation',
        },
        {
          id: 'health.operation.what',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Beskrivning av operation',
        },
        {
          id: 'health.relativesCancer',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Förälder/syskon drabbad av cancer',
        },
        {
          id: 'health.relativesCardiovascular',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Förälder/syskon drabbad av hjärt-kärlsjukdom',
        },
        {
          id: 'health.relativesDiabetes',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Förälder/syskon drabbad av diabetes',
        },
        {
          id: 'medication.current.anyFemale',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Tar läkemedel för tillfället',
          description: '(inklusive ev. hormonella preventivmedel)',
        },
        {
          id: 'medication.current.anyMale',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Tar läkemedel för tillfället',
          description: '',
        },
        {
          id: 'medication.current.what',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Beskrivning av läkemedel',
          description: '',
        },
        {
          id: 'medication.packaged',
          warning: "get('answers.medication.packaged') === 'yes'",
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Har dosförpackade läkemedel',
          description: '',
        },
        {
          id: 'medication.deliveryHelp.match',
          warning: "get('answers.medication.deliveryHelp.match') === 'yes'",
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Får hjälp med utdelning av läkemedel',
          description: '',
        },
        {
          id: 'medication.deliveryHelp.what',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Typ av hjälp med utdelning av läkemedel',
          description: '',
        },
        {
          id: 'medication.naturopathic.any',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Använder natur- eller hälsokostpreparat för tillfället',
          description: '',
        },
        {
          id: 'medication.naturopathic.what',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Vilka natur- eller hälsokostpreparat',
          description: '',
        },
        {
          id: 'allergy.penicillinMatch',
          warning: "contains(get('answers.allergy.penicillinMatch'), 'yes')",
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Har penicillin/antibiotikaallergi',
          description: '',
          options: [
            {
              value: 'yesKnows',
              label:
                'Ja, och jag vet vilken sorts penicillin eller antibiotika jag är allergisk mot.',
            },
            {
              value: 'yesDontKnow',
              label:
                'Ja, men jag vet inte vilken sorts penicillin eller antibiotika jag är allergisk mot.',
            },
            {
              value: 'no',
              label: 'Nej',
            },
            {
              value: 'dontKnow',
              label: 'Vet ej',
            },
          ],
        },
        {
          id: 'allergy.penicillinWhat',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Typ av penicillin/antibiotikaallergi',
          description: '',
          options: [
            {
              value: 'penicillins',
              label:
                'Penicilliner (t.ex. Amimox, Amoxicillin, Avopenin, Bioclavid, Calciopen, Flukloxacillin, Imacillin, Heracillin, Klaximol, Kåvepenin, Penomax, Selexid, Spektramox, Tikacillin)',
            },
            {
              value: 'azitromycin',
              label: 'Azitromycin (t.ex. Azitromax)',
            },
            {
              value: 'cefadroxil',
              label: 'Cefadroxil (t.ex. Cefamox)',
            },
            {
              value: 'ciprofloxacin',
              label: 'Ciprofloxacin (t.ex. Ciproxin)',
            },
            {
              value: 'erytromycin',
              label: 'Erytromycin (t.ex. Abboticin, Ery-Max)',
            },
            {
              value: 'klindamycin',
              label: 'Klindamycin (t.ex. Dalacin)',
            },
            {
              value: 'nitrofurantoin',
              label: 'Nitrofurantoin (t.ex. Furadantin)',
            },
            {
              value: 'norfloxacin',
              label: 'Norfloxacin (t.ex. Lexinor)',
            },
            {
              value: 'sulfa',
              label:
                'Sulfa (t.ex. Bactrim, Bactrim forte, Eusaprim, Eusaprim forte)',
            },
            {
              value: 'tetracykliner',
              label:
                'Tetracykliner (t.ex. Doxyferm, Lymelysal, Tetracyklin, Tetralysal)',
            },
            {
              value: 'trimetoprim',
              label: 'Trimetoprim (t.ex. Idotrim)',
            },
            {
              value: 'other',
              label: 'Annat',
            },
          ],
        },
        {
          id: 'allergy.penicillinOther',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Annan typ av penicillin/antibiotikaallergi',
          description: '',
        },
        {
          id: 'allergy.penicillinReaction',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Reaktion vid penicillin/antibiotikaallergi',
          description: '',
          options: [
            {
              value: 'severe',
              label:
                'Allvarlig reaktion med t.ex. andningssvårigheter och svullnad i mun och svalg',
            },
            {
              value: 'light',
              label: 'Lättare besvär såsom hudutslag och klåda',
            },
            {
              value: 'other',
              label: 'Annat',
            },
          ],
        },
        {
          id: 'allergy.penicillinReactionOther',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Fri beskrivning annan reaktion',
          description: '',
        },
        {
          id: 'allergy.medication.any',
          warning: "get('answers.allergy.medication.any') === 'yes'",
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Har övriga medicinallergier',
          description: '',
        },
        {
          id: 'allergy.medication.what',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Beskrivning av övriga medicinallergier',
          description: '',
        },
        {
          id: 'allergy.other.any',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Andra allergier',
          description: '',
        },
        {
          id: 'allergy.other.what',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Andra allergier',
          description: '',
          options: [
            {
              value: 'pollen',
              label: 'Pollen',
            },
            {
              value: 'fur',
              label: 'Pälsdjur',
            },
            {
              value: 'mite',
              label: 'Kvalster',
            },
            {
              value: 'food',
              label: 'Födoämnen',
            },
            {
              value: 'other',
              label: 'Annat',
            },
          ],
        },
        {
          id: 'allergy.other.other',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Fri beskrivning andra allergier',
          description: '',
        },
        {
          id: 'otherChoice',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Övrigt',
          description: '',
        },
        {
          id: 'other',
          important: true,
          type: 'question',
          version: '1',
          extras: {},
          label: 'Övrigt',
          description: '',
        },
      ],
      type: 'view',
      version: '1',
      validations: {
        required: true,
      },
    },
    prescriptionwarnings: {
      children: [
        {
          id: 'prescriptionwarnings.liverFunctions',
          type: 'text',
          condition: "contains(get('answers.health.issues.what'), 'liver')",
          warning: 'true',
          version: '1',
          validations: {
            required: true,
          },
          label: 'Nedsatt leverfunktion',
          description: '',
          template: "'Ja'",
        },
        {
          id: 'prescriptionwarnings.kidneyFunctions',
          type: 'text',
          condition: "contains(get('answers.health.issues.what'), 'kidney')",
          warning: 'true',
          version: '1',
          validations: {
            required: true,
          },
          label: 'Nedsatt njurfunktion',
          description: '',
          template: "'Ja'",
        },
        {
          id: 'prescriptionwarnings.bloodDisease',
          type: 'text',
          condition:
            "contains(get('answers.health.bloodDisease.what'), 'hepB') || contains(get('answers.health.bloodDisease.what'), 'hepC')",
          warning: 'true',
          version: '1',
          validations: {
            required: true,
          },
          label: 'Nedsatt leverfunktion pga blodsmitta',
          description: '',
          template: "'Ja'",
        },
        {
          id: 'allergy.penicillinMatch',
          condition: "contains(get('answers.allergy.penicillinMatch'), 'yes')",
          warning: 'true',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Har penicillin/antibiotikaallergi',
          description: '',
          options: [
            {
              value: 'yesKnows',
              label:
                'Ja, och jag vet vilken sorts penicillin eller antibiotika jag är allergisk mot.',
            },
            {
              value: 'yesDontKnow',
              label:
                'Ja, men jag vet inte vilken sorts penicillin eller antibiotika jag är allergisk mot.',
            },
            {
              value: 'no',
              label: 'Nej',
            },
            {
              value: 'dontKnow',
              label: 'Vet ej',
            },
          ],
        },
        {
          id: 'allergy.penicillinWhat',
          condition: "get('answers.allergy.penicillinMatch') === 'yesKnows'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Typ av penicillin/antibiotikaallergi',
          description: '',
          options: [
            {
              value: 'penicillins',
              label:
                'Penicilliner (t.ex. Amimox, Amoxicillin, Avopenin, Bioclavid, Calciopen, Flukloxacillin, Imacillin, Heracillin, Klaximol, Kåvepenin, Penomax, Selexid, Spektramox, Tikacillin)',
            },
            {
              value: 'azitromycin',
              label: 'Azitromycin (t.ex. Azitromax)',
            },
            {
              value: 'cefadroxil',
              label: 'Cefadroxil (t.ex. Cefamox)',
            },
            {
              value: 'ciprofloxacin',
              label: 'Ciprofloxacin (t.ex. Ciproxin)',
            },
            {
              value: 'erytromycin',
              label: 'Erytromycin (t.ex. Abboticin, Ery-Max)',
            },
            {
              value: 'klindamycin',
              label: 'Klindamycin (t.ex. Dalacin)',
            },
            {
              value: 'nitrofurantoin',
              label: 'Nitrofurantoin (t.ex. Furadantin)',
            },
            {
              value: 'norfloxacin',
              label: 'Norfloxacin (t.ex. Lexinor)',
            },
            {
              value: 'sulfa',
              label:
                'Sulfa (t.ex. Bactrim, Bactrim forte, Eusaprim, Eusaprim forte)',
            },
            {
              value: 'tetracykliner',
              label:
                'Tetracykliner (t.ex. Doxyferm, Lymelysal, Tetracyklin, Tetralysal)',
            },
            {
              value: 'trimetoprim',
              label: 'Trimetoprim (t.ex. Idotrim)',
            },
            {
              value: 'other',
              label: 'Annat',
            },
          ],
        },
        {
          id: 'allergy.penicillinOther',
          condition: "contains(get('answers.allergy.penicillinWhat'), 'other')",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Annan typ av penicillin/antibiotikaallergi',
          description: '',
        },
        {
          id: 'allergy.medication.any',
          condition: "get('answers.allergy.medication.any') === 'yes'",
          warning: 'true',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Har övriga medicinallergier',
        },
        {
          id: 'allergy.medication.what',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Beskrivning av övriga medicinallergier',
        },
        {
          id: 'medication.packaged',
          condition: "get('answers.medication.packaged') === 'yes'",
          warning: 'true',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Har dosförpackade läkemedel',
          description: '',
        },
      ],
      type: 'view',
      version: '1',
      validations: {
        required: true,
      },
    },
  },
  label: 'Hälsoprofil',
  index: '0',
};
